import Form from 'react-bootstrap/Form';
import React, { useState, useEffect, useRef } from "react"
import {useNavigate} from 'react-router-dom';
import PanelInputMobile from '../../components/panel/PanelInputMobile.js';
import FailTitleDiv from '../../components/shared/TitleDiv.js';
import LongButton from '../../components/shared/LongButton.js';
import '../../css/EnrollM1.css';

function EnrollM1(props) {
    
    const navigate = useNavigate();
    const PUBLIC_URL =process.env.PUBLIC_URL;
    const url = new URL(window.location.href);
    let baseUrl = `${url.protocol}//${url.host}/`;

    if (process.env.REACT_APP_API_URL != ""){
      baseUrl = process.env.REACT_APP_API_URL;
    }
    const eventName = window.name;
    const bgColor = process.env.REACT_APP_BG_COLOR;
    let tracking_channel = "others";

    if (props.channel !== ""){
      tracking_channel = props.channel;
    }
    const geocodes = [
        {id:1, display: '香港(+852)', value: '852', placeHolder: '例子:55667788', maxLength : 8},
        {id:2, display: '內地(+86)', value: '86', placeHolder: '例子:11122223333', maxLength : 11},
        {id:3, display: '澳門(+853)', value: '853', placeHolder: '例子:55667788', maxLength : 8}
    ];
    
    const [settings, setSettings] = useState({
      Event_Status: "",
      Is_Maintenance: false,
      Event_Picture: "",
      Event_Button_Wording: "",
      Event_PreOrder_Method: "",
      Event_PreOrder_TnC: "",
      AllButton_Color: "",
      AllButton_FontColor: "",
      AllTitle_Color: "#FFFFFF",
      AllTitle_FontColor: "#FFFFFF",
      AllBackground_Color : "#FFFFFF"
    });  
    
    const [inputs, setInputs] = useState({
      geocode : "",
      mobile : "",
      geocode2 : "",
      mobile2 : "",
      channel : tracking_channel,
      tracking_channel : tracking_channel
    });
      const style = {
        margin: '50px'
      };
    useEffect(() => {
        let GetEventStatusURL = baseUrl + "frontend/api/Enroll/GetEventStatus";
        fetch(GetEventStatusURL, {
          "method": "POST",
          "headers": {
            'Content-Type': 'application/json'
          },
          "body": JSON.stringify({
            "event_Name": eventName
          })
        })
        .then(response => response.json())
        .then(response => { 
          let result = JSON.parse(JSON.stringify(response));
          if(props.isdebugmode) console.log(result);
          setSettings(previousState => {
            return { 
              ...previousState,
              Event_Status : result.Event_Status,
              Is_Maintenance: result.Is_Maintenance,
              Event_Button_Wording : result.Event_Button_Wording,
              Event_Picture : result.Event_Picture,
              Event_PreOrder_Method : result.Event_PreOrder_Method,
              Event_PreOrder_TnC : result.Event_PreOrder_TnC,
              AllButton_Color : result.AllButton_Color,
              AllButton_FontColor : result.AllButton_FontColor,
              AllTitle_Color : result.AllTitle_Color,
              AllTitle_FontColor : result.AllTitle_FontColor,
              AllBackground_Color : result.AllBackground_Color
            }
          });

          if (result.Event_Status !== "Processing" && result.Event_Status !== "Testing"){
            navigate('../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }
        })
        .catch(err => { if(props.isdebugmode) console.log(err); });

        window.QueueIt && window.QueueIt.validateUser();
      }, []);

    const set = name => {
    return ({ target: { value } }) => {
      if (value == null){
        setInputs(oldValues => ({...oldValues, [name]: "" }));
      } else {
        setInputs(oldValues => ({...oldValues, [name]: value }));
      }
    }
  };

  const submitButtonOnClick = (e) => {
    if (inputs.geocode == "" || inputs.geocode2 == "")
    {
      alert("請選擇區號。");
    }
    else if (inputs.mobile == "" || inputs.mobile2 == "")
    {
      alert("請輸入手提電話號碼。");
    }
    else if (inputs.geocode != inputs.geocode2 || inputs.mobile != inputs.mobile2)
    {
      alert("所輸入的手提電話號碼不相符。請重新輸入。");
    }
    else
    {
        VertifyonSuccess();
    }
  }

  const VertifyonSuccess = (e) => {
    let url = baseUrl + "frontend/api/Enroll/CheckValidEnrollment";

    let postData ={
      "Event_Name" : eventName,
      "Geocode": inputs.geocode,
      "Mobile": inputs.mobile,
      "CreatedDate": getClosestWednesday()
    };
    
    fetch(url, {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json'
      },
      "body": JSON.stringify(postData)
    })
    .then(response => response.json())
    .then(response => { 
      let result = JSON.parse(JSON.stringify(response));
      
      if(props.isdebugmode) console.log(JSON.stringify(response));

      if(result.isValid){
        navigate('../' + PUBLIC_URL + '/' + eventName + '/multi/enrollm1step2?src=' + props.channel + '&geocode=' + inputs.geocode + '&mobile=' + inputs.mobile);
      } else if (result.hasCurrentCycleTxn) {
        navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-cct');
      } else {
        navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-invalid-multi-pickup');
       }    
    })
    .catch(err => { console.log(err); }); 
  }

  return (
    <>
        <Form>
                <FailTitleDiv class="title" title="產品預購" bgColor={settings.AllTitle_Color} fontColor={settings.AllTitle_FontColor}></FailTitleDiv>
                <div className="d-grid" style={{backgroundColor: settings.AllBackground_Color}}>
                    <PanelInputMobile geoList={geocodes} setGeocode={set('geocode')} setMobile={set('mobile')} setRepeatGeocode={set('geocode2')} setRepeatMobile={set('mobile2')}></PanelInputMobile>
                    <LongButton class="enroll-button" text="下一步" bgColor={settings.AllButton_Color} fontColor={settings.AllButton_FontColor}  onClick={() => { submitButtonOnClick(); }} ></LongButton>
                </div>
        </Form>
    </>
  );
}

function getClosestWednesday() {
    const today = new Date();
    const currentDay = today.getDay();
    const daysUntilNextWednesday = (3 - currentDay + 7) % 7;
    const closestWednesday = new Date(today.setDate(today.getDate() + daysUntilNextWednesday));
  
    const year = closestWednesday.getFullYear();
    const month = String(closestWednesday.getMonth() + 1).padStart(2, '0');
    const day = String(closestWednesday.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }

export default EnrollM1;
